import { render } from "./WorkPlanPerson.vue?vue&type=template&id=00ab6f04"
import script from "./WorkPlanPerson.vue?vue&type=script&lang=js"
export * from "./WorkPlanPerson.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__